import { ISupplierDocumentDetails, SupplierDocumentStatus } from 'types';

export enum DocuProcessingStep {
  UPLOAD,
  FORMAL_INSPECTION,
  CONTENT_INSPECTION,
  RECORD_LIBRARY_TRANSFER,
}

export function getCurrentDocumentProcessingStep(
  document: ISupplierDocumentDetails,
): DocuProcessingStep {
  switch (document.documentProcessingStatus) {
    case SupplierDocumentStatus.FORMAL_CONTROL:
    case SupplierDocumentStatus.FORMAL_CONTROL_FAILED:
      return DocuProcessingStep.FORMAL_INSPECTION;
    case SupplierDocumentStatus.CONTENT_CONTROL:
    case SupplierDocumentStatus.CONTENT_CONTROL_FAILED:
      return DocuProcessingStep.CONTENT_INSPECTION;
    case SupplierDocumentStatus.RECORD_LIBRARY_TRANSFER:
    case SupplierDocumentStatus.RECORD_LIBRARY_TRANSFER_FAILED:
    case SupplierDocumentStatus.COMPLETED:
      return DocuProcessingStep.RECORD_LIBRARY_TRANSFER;
    // TODO: Add info about timeout
    default:
      return DocuProcessingStep.UPLOAD;
  }
}

export function isStepFailed(
  documentProcessingStatus: SupplierDocumentStatus,
): boolean {
  return [
    SupplierDocumentStatus.FORMAL_CONTROL_FAILED,
    SupplierDocumentStatus.CONTENT_CONTROL_FAILED,
    SupplierDocumentStatus.RECORD_LIBRARY_TRANSFER_FAILED,
  ].includes(documentProcessingStatus);
}
